import { Condition } from 'Component/others';
import getStatusColor from 'Helper/getStatusColor';
import { TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';

export const tableListRest = [
  {
    name: 'Jenis Istirahat',
    width: 200,
    key: 'breakType',
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: 'Jam Mulai',
    width: 200,
    key: 'startedTime',
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: 'Jam Selesai',
    width: 200,
    key: 'endedTime',
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: 'Durasi',
    width: 200,
    key: 'duration',
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: 'Status',
    width: 200,
    key: 'status',
    component: ({ value, values }) => {
      const notes = values?.notes;
      const isViolation = values?.isViolation;
      const status = value;

      const color = getStatusColor(isViolation);

      return (
        <TextRegular className={`${styles['column__status--container']} ${styles['column__text--truncate']}`}>
          <span style={{ color }}>{status}</span>
          <Condition statement={notes}>
            <span className={styles['column__status--separator']}>|</span>
            <span>{notes}</span>
          </Condition>
        </TextRegular>
      );
    },
  },
];
